module.exports = __webpack_public_path__ + "assets/0c884ac9370cc3004c2a39a740e376f4.mp3";